module.exports = __webpack_public_path__ + "static/media/slide-4.3a93cbea.jpg";